import Cookies from 'universal-cookie'

export function extractSegmentAnonymousIdFromCookie(
  simpleCookieObject: Record<string, string> | null = null,
) {
  const cookies = new Cookies(simpleCookieObject)
  const segmentAnonymousId = cookies.get<string | undefined>('ajs_anonymous_id')

  return segmentAnonymousId
}
